import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-html-viewer',
  templateUrl: './html-viewer.component.html',
  styleUrls: ['./html-viewer.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom
})
export class HtmlViewerComponent implements OnInit {


  @Input() public msgBody:any;
  EmailMsgBody:any;
  constructor() {
  }

  ngOnInit(): void {
    //debugger
    this.EmailMsgBody = this.msgBody;
  }

}
